"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisibilityTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.VisibilityTransport = typebox_1.Type.Object({
    key: typebox_1.Type.String(),
    label: typebox_1.Type.String(),
});
//# sourceMappingURL=visibility.js.map